import React from 'react';

import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { useCreateAllowListMember } from 'src/features/parkingManagement/api/AllowListAPI/useCreateAllowListMember';
import { LIST_ALLOW_LIST_MEMBERS_RESOURCE } from 'src/features/parkingManagement/api/AllowListAPI/useListAllowListMembers';
import AllowListMemberFormModal from 'src/features/parkingManagement/components/AllowLists/forms/AllowListMemberFormModal';
import { allowListMessages } from 'src/features/parkingManagement/utils/allowListMessages';
import { ICON_MAP } from 'src/features/parkingStatus/utils';
import { queryClient } from 'src/lib/react-query';
import { type DataTableNewEntryProps } from 'src/registry/components/table/types';
import { toast } from 'src/registry/hooks/UseToast';
import { generalMessages } from 'src/utils/messages';

import type { AllowListMember } from 'src/features/parkingManagement/types/allowList';

interface CreateEntityGroupFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

export default function CreateAllowListMemberFormModal<TData>({
    className,
    semantics,
}: CreateEntityGroupFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { parkingId = '', listId = '' } = useParams();

    const { mutate, isPending } = useCreateAllowListMember({
        onSuccess: ({ name }: AllowListMember) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_ALLOW_LIST_MEMBERS_RESOURCE] });
            toast({
                title: formatMessage(allowListMessages.createMemberSuccess),
                description: formatMessage(allowListMessages.createMemberSuccessDescription, { entry: name }),
            });
        },
    });

    return (
        <AllowListMemberFormModal
            className={className}
            mutate={(values, onSuccess) => mutate({ parkingId, listId, ...values }, { onSuccess })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(allowListMessages.createMemberModalSubtitle)}
        />
    );
}
